import VeeValidate, { Validator } from 'vee-validate';
import Vue from 'vue';

import validationMessages from 'vee-validate/dist/locale/ru';


Vue.use(VeeValidate);

Validator.localize('ru', validationMessages);

// localize({
//     en: {
//         messages: {
//             required: 't22222his field is required',
//             min: 'this field must have no less than {length} characters',
//             max: (field, { length }) => `The ${field} must have no more than ${length} characters`
//         }
//     }
// });

// extend('required', {
//     validate: value => !!value
// });

// import { ValidationProvider, extend } from 'vee-validate';

// Add a rule.
// extend('secret', {
//     validate: value => value === 'example',
//     message: 'This is not the magic word'
// });

// Register it globally
// Vue.component('ValidationProvider', ValidationProvider);